






















import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { ScriptAction, ScriptStatus } from '@/constants/scripts'
import { SCRIPTS__MAKE_ACTION } from '@/store/actions'
import { RouteNames } from '@/router'

import type { AxiosResponse, AxiosPromise } from 'axios'
import type { ScriptActionPayload } from '@/models/scripts'
import type { UserScope } from '@/models/users'

interface Data {
  inProgress: boolean
}

interface Methods {
  [SCRIPTS__MAKE_ACTION]: (data: ScriptActionPayload) => AxiosPromise
  makeAction: (action: ScriptAction) => Promise<AxiosResponse<unknown>>
  deleteItem: () => void
  unPublish: () => void
}

interface Computed {
  canDoScope: (checkingScope: UserScope) => boolean
  showRoute: string
  isPublished: boolean
}

interface Props {
  scriptId: string
  instanceId: string
  status: ScriptStatus
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    scriptId: {
      required: true,
    },
    instanceId: {
      required: false,
    },
    status: {
      required: true,
    },
  },
  data() {
    return {
      inProgress: false,
    }
  },
  computed: {
    ...mapGetters(['canDoScope']),
    showRoute(): string {
      return `/scripts/${this.scriptId}`
    },
    isPublished(): boolean {
      return this.status === ScriptStatus.Publish
    },
  },
  methods: {
    ...mapActions([SCRIPTS__MAKE_ACTION]),
    makeAction(action: ScriptAction): Promise<AxiosResponse<unknown>> {
      this.inProgress = true

      return this[SCRIPTS__MAKE_ACTION]({
        action,
        id: this.scriptId,
        instance: this.instanceId,
      })
        .then(response => {
          this.inProgress = false
          return response
        })
        .catch(err => {
          this.inProgress = false
          throw err
        })
    },
    deleteItem(): void {
      if (this.inProgress) {
        return
      }

      this.$useConfirmDialog([this.$tc('script.actions.removeConfirm'), {
          type: 'danger',
          okText: this.$tc('common.remove'),
          cancelText: this.$tc('common.cancel'),
        }], async () => {
        await this.makeAction(ScriptAction.DeleteItem)
        this.$router.replace({ name: RouteNames.ScriptsPage})
      })
    },
    unPublish(): void {
      if (this.inProgress) {
        return
      }

      this.$useConfirmDialog(
        this.$tc('script.actions.unpublishConfirm'),
        () => {
          this.makeAction(ScriptAction.UnPublish)
        },
      )
    },
  },
})
